import React, { FC } from 'react';
import cx from 'classnames';
import { useIntl } from 'react-intl';

import { IconArrowLeft } from '@xingternal/icons';

import { useTeampermissionsUserResources } from '@/hooks/useTeampermissionsUserResources';
import { trackingParams } from '@/utils/tracking';
import { MANAGE_USERS_PERMISSION } from '@/config/constants';
import { EXTERNAL_LINKS } from '@/routes';

import styles from './LoggedInPage.css';
import BaseButton from '../BaseButton';

type LoggedInHeaderProps = {
  isBrandManagerEditor: boolean;
  showBackToCompanies: boolean;
};
export const LoggedInHeader: FC<LoggedInHeaderProps> = ({
  isBrandManagerEditor,
  showBackToCompanies,
}) => {
  const { formatMessage } = useIntl();

  const { data: teampermissionsData, loading: tpLoading } =
    useTeampermissionsUserResources({
      permissions: MANAGE_USERS_PERMISSION,
    });

  if (tpLoading) return null;

  const teampermissionsLength =
    teampermissionsData?.viewer?.teamPermissions?.userResources?.collection
      ?.length;

  const showTeampermissionsButton =
    teampermissionsLength && teampermissionsLength > 0;

  return (
    <>
      <div
        data-testid="logged-in-header"
        className={cx(
          styles.buttonsContainer,
          showBackToCompanies ? styles.backToCompanies : undefined,
        )}
      >
        {showBackToCompanies ? (
          <BaseButton to={'/companies'} icon={IconArrowLeft} size="small">
            {formatMessage({ id: 'SE_LABEL_COMPANIES' })}
          </BaseButton>
        ) : null}
        <div className={styles.buttonsContainer}>
          {showTeampermissionsButton ? (
            <BaseButton
              className={styles.button}
              size="small"
              variant="secondary"
              href={EXTERNAL_LINKS.teampermissions()}
              trackingAttributes={trackingParams.teampermissions}
            >
              {formatMessage({ id: 'CP_TEAMPERMISSIONS' })}
            </BaseButton>
          ) : null}
          {isBrandManagerEditor ? (
            <BaseButton
              className={styles.button}
              size="small"
              variant="secondary"
              href={EXTERNAL_LINKS.brandmanager()}
              trackingAttributes={trackingParams.brandmanager}
            >
              {formatMessage({ id: 'CP_BRANDMANAGER' })}
            </BaseButton>
          ) : null}
          <BaseButton
            className={cx(styles.button, styles.createProfileButton)}
            size="small"
            variant="primary"
            href={EXTERNAL_LINKS.newCompany}
            trackingAttributes={trackingParams.createProfile}
          >
            {formatMessage({ id: 'CP_CREATE_FREE_PROFILE' })}
          </BaseButton>
        </div>
      </div>
    </>
  );
};
